//进入主页前,处理sso登录
import store from "@/store"
export function sso(to, from, next) {
    const isDDE = process.env.VUE_APP_IS_DDE == 'true';
    const isGeovisearth = process.env.VUE_APP_APP_TYPE == 'geovisearth';
    const authMode = process.env.VUE_APP_AUTH_MODE || (isDDE ? 'dde' : (isGeovisearth ? 'geovisearth' : 'mapscloud'));
    if (authMode === 'mapscloud' && to.query.session) {
        store.dispatch("auth/loginBySocial",to.query.session)
    }
    next()
}
